import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, ModelDataService, DropdownPicklistComponent, ConfirmationDialogButtons, DatePickerPopup2Component, UserRightsService, ErrorHandlerService, NotificationService, DateTimePickerPopupComponent, InlineContainerService, BaseInlineContainer } from 'yt-ng-framework';
import { EOtpremnica } from './eotpremnica';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as var_config from '../../var_config';
import { List } from 'immutable';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { PodVrstaDokumentaStavkaView } from 'src/app/lookups/podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Company } from 'src/app/admin/company/company';
import { TipOtpremnice } from '../tip-otpremnice/tip-otpremnice';
import { NacinOtpreme } from '../nacin-otpreme/nacin-otpreme';
import { Komitent } from 'src/app/lookups/komitent/komitent';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { CompanyView } from 'src/app/admin/company/company-view';
import { FirmaObjekat } from 'src/app/admin/company/firma-objekat/firma-objekat';
import { FirmaObjekatView } from 'src/app/admin/company/firma-objekat/firma-objekat-view';
import { KomitentObjekatView } from 'src/app/lookups/komitent-objekat/komitent-objekat-view';
import { EOtpremnicaPrevozInlineUpdateComponent } from './eotpremnica-prevoz-inline-update.component';
import { EOtpremnicaPrevoz } from './eotpremnica-prevoz';
import { NgZone } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EOtpremnicaView } from './eotpremnica-view';
import { CheckTezinaIsporuke, CheckZapreminaIsporuke } from '../_validators/tezina-zapremina.validator';
import { QueryValueType } from '@angular/compiler/src/core';
import { element } from 'protractor';
import { translate } from '@angular/localize/src/utils';


@Component({
    selector: 'yt-eotpremnica-update',
    templateUrl: './eotpremnica-update.component.html'
})
export class EOtpremnicaUpdateComponent
    extends BaseUpdateComponent<EOtpremnica>
    implements OnInit {

    izlazna: boolean = false;
    parameterList: List<QueryParameter> = List([]);
    PrimaocID: QueryParameter = new QueryParameter();
    podvrstaDokumentaGn: string = null;
    parameterListZaPrimaoce: List<QueryParameter> = List([]);
    parameterListZaObjektePrimaoca: List<QueryParameter> = List([]);
    Domaca: QueryParameter = new QueryParameter();
    hasUserRights: boolean;
    varConfig = var_config;
    parameterListDatum: List<QueryParameter> = List([]);
    danParametar: QueryParameter = new QueryParameter();
    mesecParametar: QueryParameter = new QueryParameter();
    godinaParametar: QueryParameter = new QueryParameter();
    tipOtpremniceItems: List<TipOtpremnice>;
    nacinOtpremeItems: List<NacinOtpreme>;
    primaocItems: List<KomitentView>;
    objekatPosiljaocaItems: List<FirmaObjekatView>;
    objekatPrimaocaItems: List<KomitentObjekatView>;
    selektovaniPosiljaoc: CompanyView;
    angazovanPrevoznik: boolean;
    sopstveniPrevoz: boolean
    brojDecimala: number = 0;
    dozvoliSnimanje = true;
    private readonly SOPSTVENI_PREVOZ = 'Sopstveni prevoz';

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected router: Router,
        protected changeDetectorRef: ChangeDetectorRef,
        protected modelDataService: ModelDataService,
        protected userRightsService: UserRightsService,
        protected errorService: ErrorHandlerService
        , private ngZone: NgZone
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService, router)
    }

    collapsedOtpremnica: boolean = false;
    collapsedDetaljiOOtpremnici: boolean = true;
    collapsedDetaljiOPosiljaocu: boolean = true;
    collapsedDetaljiOOtpremi: boolean = true;
    collapsedDetaljiOPrimaocu: boolean = true;
    collapsedDetaljiODostavi: boolean = true;

    @ViewChild('dtpDatumDokumenta', { static: true }) dtpDatumDokumenta: DatePickerPopup2Component;
    @ViewChild('prevozInline', { static: true }) prevozInline: any;
    @ViewChild('dtPickerPlaniraniPocetakOtpreme', { static: true }) dtPickerPlaniraniPocetakOtpreme: DateTimePickerPopupComponent;

    @ViewChild('baseInlineContainer', { static: false }) baseInlineContainer: BaseInlineContainer<EOtpremnica>;
    @ViewChild('baseInlineContainer1', { static: false }) baseInlineContainer1: BaseInlineContainer<EOtpremnica>;
    @ViewChild('baseInlineContainer2', { static: false }) baseInlineContainer2: BaseInlineContainer<EOtpremnica>;

    @ViewChild('formTop', { static: false }) formTop: ElementRef;

    parametersForPodvrstaDokumentStavka: List<QueryParameter> = List([]);
    PodvrstaDokumentStavkaIDParameter: QueryParameter = new QueryParameter();

    ngOnInit() {
        super.ngOnInit();
        this.loadCompanyData();

        this.izlazna = this.modelData.MainTitle === 'Izlazna otpremnica';

        // let parameterList: List<QueryParameter> = List(this.modelData.MainList.GetParameters);
        // this.TransferParameters = this.TransferParameters.set(0, parameterList);

        // parameterList.clear();
        // parameterList = List([new QueryParameter('Izlazna', this.izlazna)]);
        // this.TransferParameters = this.TransferParameters.set(1, parameterList);

        this.TransferParameters = this.TransferParameters.set(
            0,
            List(this.modelData.MainList.GetParameters)
        );

        this.TransferParameters = this.TransferParameters.set(
            1,
            List([new QueryParameter('Izlazna', this.izlazna)])
        );

        // Privremeni patch da zaustavi FW grešku "navigateTo of undefined"
        const originalOnDateChange = (DateTimePickerPopupComponent as any).prototype.onDateChange;

        (DateTimePickerPopupComponent as any).prototype.onDateChange = function (...args) {
            try {
                return originalOnDateChange.apply(this, args);
            } catch (err) {
                if (err?.message?.includes('navigateTo')) {
                    console.warn('⚠️ DateTimePickerPopupComponent: dp.navigateTo() preskočen jer dp nije još spreman.');
                    return;
                }
                throw err;
            }
        };



        let dateNow = new Date();
        let datum: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate())
        this.forDatumParameter(datum);

        this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'EOTPREMNICA.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Broj', Validators.required, 'required', 'EOTPREMNICA.BRDOK.VALIDATION.REQUIRED');
        this.addValidatorToFc('Broj', Validators.maxLength(20), 'maxlength', 'EOTPREMNICA.BRDOK.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('Datum', Validators.required, 'required', 'EOTPREMNICA.DATDOK.VALIDATION.REQUIRED');
        this.addValidatorToFc('TipOtpremniceID', Validators.required, 'required', 'EOTPREMNICA.TIPOTPREMNICE.VALIDATION.REQUIRED');
        this.addValidatorToFc('Povrat', Validators.required, 'required', 'EOTPREMNICA.POVRAT.VALIDATION.REQUIRED');
        this.addValidatorToFc('Napomena', Validators.maxLength(500), 'maxlength', 'EOTPREMNICA.NAPOMENA.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('BrojOtpremnice', Validators.required, 'required', 'EOTPREMNICA.BROJOTPREMNICE.VALIDATION.REQUIRED');
        this.addValidatorToFc('DatumOtpremnice', Validators.required, 'required', 'EOTPREMNICA.DATUMOTPREMNICE.VALIDATION.REQUIRED');
        this.addValidatorToFc('TipOtpremnice', Validators.required, 'required', 'EOTPREMNICA.TIPOTPREMNICE.VALIDATION.REQUIRED');
        this.addValidatorToFc('NacinOtpremeID', Validators.required, 'required', 'EOTPREMNICA.NACINOTPREME.VALIDATION.REQUIRED');
        this.addValidatorToFc('PrimaocID', Validators.required, 'required', 'EOTPREMNICA.PRIMAOC.VALIDATION.REQUIRED');
        this.addValidatorToFc('NacinOtpreme', Validators.required, 'required', 'EOTPREMNICA.NACINOTPREME.VALIDATION.REQUIRED');
        this.addValidatorToFc('PibPrimaoca', Validators.required, 'required', 'EOTPREMNICA.PIBPRIMAOCA.VALIDATION.REQUIRED');
        this.addValidatorToFc('NazivPrimaoca', Validators.required, 'required', 'EOTPREMNICA.NAZIVPRIMAOCA.VALIDATION.REQUIRED');
        this.addValidatorToFc('UlicaPrimaoca', Validators.required, 'required', 'EOTPREMNICA.ULICAPRIMAOCA.VALIDATION.REQUIRED');
        this.addValidatorToFc('GradPrimaoca', Validators.required, 'required', 'EOTPREMNICA.GRADPRIMAOCA.VALIDATION.REQUIRED');
        this.addValidatorToFc('PostanskiBrojPrimaoca', Validators.required, 'required', 'EOTPREMNICA.POSTANSKIBROJPRIMAOCA.VALIDATION.REQUIRED');
        this.addValidatorToFc('MaticniBrojPrimaoca', Validators.required, 'required', 'EOTPREMNICA.MATICNIBROJPRIMAOCA.VALIDATION.REQUIRED');
        this.addValidatorToFc('UlicaDostave', Validators.required, 'required', 'EOTPREMNICA.ULICADOSTAVE.VALIDATION.REQUIRED');
        this.addValidatorToFc('GradDostave', Validators.required, 'required', 'EOTPREMNICA.GRADDOSTAVE.VALIDATION.REQUIRED');
        this.addValidatorToFc('PostanskiBrojDostave', Validators.required, 'required', 'EOTPREMNICA.POSTANSKIBROJDOSTAVE.VALIDATION.REQUIRED');
        // this.addValidatorToFc('PlaniraniPocetakOtpreme', Validators.required, 'required', 'EOTPREMNICA.DATUMDOSTAVE.VALIDATION.REQUIRED');
        this.addValidatorToFc('PlaniraniZavrsetakOtpreme', Validators.required, 'required', 'EOTPREMNICA.VREMEDOSTAVE.VALIDATION.REQUIRED');
        this.addValidatorToFc('UlicaOtpreme', Validators.required, 'required', 'EOTPREMNICA.ULICAOTPREME.VALIDATION.REQUIRED');
        this.addValidatorToFc('GradOtpreme', Validators.required, 'required', 'EOTPREMNICA.GRADOTPREME.VALIDATION.REQUIRED');
        this.addValidatorToFc('PostanskiBrojOtpreme', Validators.required, 'required', 'EOTPREMNICA.POSTANSKIBROJOTPREME.VALIDATION.REQUIRED');
        this.addValidatorToFc('StvarnoVremeDostave', Validators.required, 'required', 'EOTPREMNICA.STVARNOVREMEDOSTAVE.VALIDATION.REQUIRED');

        this.baseFormGroup.setValidators([this.baseFormGroup.validator,
        checkDatumeSaDatumomDokumenta('Datum', this),
        CheckTezinaIsporuke('TezinaIsporuke', 'JedinicaMereZaTezinu'),
        CheckZapreminaIsporuke('ZapreminaIsporuke', 'JedinicaMereZaZapreminu'),
        checkByNacinOtpremeLicno('NacinOtpremeID', 'KurirIme', 'KurirPrezime', 'KurirLK')].filter(fn => typeof fn === 'function'));

        this.baseFormGroup.updateValueAndValidity({ emitEvent: false });

        this.IDProcessed
            .subscribe((value) => {

                // if (this.Item.ID==-1)
                // {
                //     const date = new NgbDate(2025, 1, 1);
                //     this.baseFormGroup.patchValue({"PlaniraniPocetakOtpreme":date});
                //     this.baseFormGroup.get('PlaniraniPocetakOtpreme').updateValueAndValidity();

                // }

                if (this.parameterListZaPrimaoce && this.parameterListZaPrimaoce.size == 0) {
                    this.Domaca.Name = "Domaca";
                    this.Domaca.Value = "true";
                    this.parameterListZaPrimaoce = this.parameterListZaPrimaoce.push(this.Domaca);
                }

                if (value && this.Item.ID == -1) {
                    this.dozvoliSnimanje = false;
                    this.collapsedOtpremnica = false;
                    this.collapsedDetaljiOOtpremnici = true;
                    this.collapsedDetaljiOPosiljaocu = true;
                    this.collapsedDetaljiOOtpremi = true;
                    this.collapsedDetaljiOPrimaocu = true;
                    this.collapsedDetaljiODostavi = true;

                    if (this.baseFormGroup.get('PrimaocID').value){
                        this.parameterListZaObjektePrimaoca = List([new QueryParameter('KomitentID', this.baseFormGroup.get('PrimaocID').value)]);
                    }
                    else
                        this.parameterListZaObjektePrimaoca = List([new QueryParameter('KomitentID', -1)]);
                    


                    // this.TransferParameters = List([]);

                    // if (this.fcd["NacinOtpremeID"] && this.fcd["NacinOtpremeID"].IsVisible) {
                    //     this.baseFormGroup.patchValue({ NacinOtpremeID: 1 });
                    //     this.baseFormGroup.get('NacinOtpremeID').updateValueAndValidity();
                    // }

                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
                    this.baseFormGroup.get('Broj').enable();
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                    this.baseFormGroup.get('Datum').enable();
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    let dateNow = new Date();
                    let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
                    this.baseFormGroup.patchValue({ Datum: date });
                    this.baseFormGroup.get('Datum').updateValueAndValidity();

                    let _stvarnoVremeOtpreme: Date = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate(), dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
                    this.baseFormGroup.patchValue({ StvarnoVremeDostave: _stvarnoVremeOtpreme.toISOString() });
                    this.baseFormGroup.get('StvarnoVremeDostave').updateValueAndValidity();

                    this.PrimaocID.Name = "PrimaocID";
                    if (this.baseFormGroup.get('PrimaocID').value) {
                        this.PrimaocID.Value = this.baseFormGroup.get('PrimaocID').value;
                    }
                    else
                        this.PrimaocID.Value = -1;
                    this.parameterList = this.parameterList.push(this.PrimaocID);

                    if (dateNow) {
                        let datum: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate())
                        this.forDatumParameter(datum);
                    }

                    //this.baseDataService.GetData()
                    //ako firma nije u sistemu PDVa i postoji samo jedna napomena o poreskom oslobođenju treba staviti po default-u tu napomenu u txtBox 

                    // naziv kontrolera
                    // naziv metode iz kontrolera koju pozivam
                    // parametri koji se toj metodi prodleđuju
                    // naziv modela sa klijentske strane                    

                    // this.baseDataService.Get('firma', 'GetCompanyIdView', null, CompanyView)
                    //     .subscribe((data: any) => {
                    //         if (data) {
                    //             this.selektovaniPosiljaoc = data as CompanyView;
                    //         }
                    //     })


                    //this.dtpDatumDokumenta.ResetMinMaxDate();
                    // this.TransferParameters = List([]);
                    // this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
                    // this.baseInlineContainer.baseDetailListSum.calculate();
                    this.enableControls();
                    this.parametersForPodvrstaDokumentStavka = List([]);
                    this.PodvrstaDokumentStavkaIDParameter.Name = "PodVrstaDokumentaStavkaID";
                    this.PodvrstaDokumentStavkaIDParameter.Value = this.PodvrstaDokumentaItems.get(0)['ID'];
                    this.parametersForPodvrstaDokumentStavka = this.parametersForPodvrstaDokumentStavka.push(this.PodvrstaDokumentStavkaIDParameter);
                }
                else {
                    this.dozvoliSnimanje = true;
                    // this.collapsedOtpremnica = true;
                    this.collapsedDetaljiOOtpremnici = false;
                    this.collapsedDetaljiOPosiljaocu = false;
                    this.collapsedDetaljiOOtpremi = false;
                    this.collapsedDetaljiOPrimaocu = false;
                    this.collapsedDetaljiODostavi = false;

                    if (this.Item.ID > 0) {
                        this.scrollToFormTopDeferred();
                    }


                    if (!this.izlazna) {
                        this.baseFormGroup.disable();
                        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
                    }
                    else
                        this.disableControls();
                    let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.Item)]);
                    // this.TransferParameters = this.TransferParameters.set(1, parameterList);
                    // parameterList.clear();

                    // this.baseInlineContainer.baseDetailListSum.Parameters=this.TransferParameters;
                    // this.baseInlineContainer.baseDetailListSum.calculate();

                    if (this.baseFormGroup.get('Datum').value != null && !this.hasUserRights) {
                        let datum: NgbDate = this.baseFormGroup.get('Datum').value;
                        if (this.dtpDatumDokumenta) {
                            this.dtpDatumDokumenta.MinDate = new NgbDate(datum.year, datum.month, 1);
                        }
                        let maxDate = new Date(datum.year, datum.month, 1);
                        maxDate.setDate(maxDate.getDate() - 1);
                        if (this.dtpDatumDokumenta) {
                            this.dtpDatumDokumenta.MaxDate = new NgbDate(maxDate.getFullYear(), maxDate.getMonth() + 1, maxDate.getDate());
                        }
                    }

                    if (this.baseFormGroup.get('Datum').value) {
                        let datum: NgbDate = this.baseFormGroup.get('Datum').value;
                        this.forDatumParameter(datum);
                    }
                    // if(this.baseFormGroup.get('NapomenaZaPdvOsl').value != null && this.baseFormGroup.get('NapomenaZaPdvOsl').value != '')
                    //     this.visibleNapomenaZaPdvOsl = true;

                    // Normalizuj izvedena/duplirana polja (npr. datume) da FW ne prijavljuje "lažne" izmene
                    // samo zato što je tip vrednosti različit (ISO string vs NgbDate).

                    //this.syncDatumOtpremniceWithDatumIfNeeded();
                    // this.refreshSavedState();           
                }
            })

        let _this = this;
        this.ItemSaved
            .subscribe((data: EOtpremnicaView) => {
                this.disableControls();
                this.baseDataService.GetByID(this.modelData.MainList.ModelName, data.ID, this.modelData.MainList.ModelClass)
                    .subscribe((eotpremnica: EOtpremnica) => {
                        _this.Item = eotpremnica;
                        _this.baseFormGroup.patchValue(_this.Item);
                        _this.SavedItem = _this.baseFormGroup.getRawValue();

                        //_this.syncDatumOtpremniceWithDatumIfNeeded();
                        //_this.refreshSavedState();

                    })

            })
    }

    pamtiVrednostObjekatPrimaocaID: number;

    onPrimaocSelect(value) {
        if (value){
            this.parameterListZaObjektePrimaoca=List([]);
            this.parameterListZaObjektePrimaoca = List([new QueryParameter('KomitentID', value.ID)]);
            if(this.pamtiVrednostObjekatPrimaocaID && this.pamtiVrednostObjekatPrimaocaID!=value.ID){
                this.baseFormGroup.patchValue({ObjekatPrimaocaID:null});
                this.baseFormGroup.get('ObjekatPrimaocaID').updateValueAndValidity();
            }      
            this.pamtiVrednostObjekatPrimaocaID=value.ID;
        }

    }

    enableControls() {
        this.baseFormGroup.enable();
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
    }

    disableControls() {
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
        this.baseFormGroup.get('Broj').disable();
        this.baseFormGroup.get('Broj').updateValueAndValidity();
        this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
    }

    PodvrstaDokumentaItems;
    PodvrstaDokumentaGetItems(items) {
        this.PodvrstaDokumentaItems = items;
    }

    private syncDatumOtpremniceWithDatumIfNeeded(): void {
        const datum = this.baseFormGroup.get('Datum')?.value as NgbDate | null;
        if (!datum) return;

        const currentRaw = this.baseFormGroup.get('DatumOtpremnice')?.value;
        const current = this.normalizeToNgbDate(currentRaw);

        if (!this.ngbDateEquals(current, datum)) {
            this.baseFormGroup.get('DatumOtpremnice')?.patchValue(datum, { emitEvent: false });
            this.baseFormGroup.get('DatumOtpremnice')?.updateValueAndValidity({ emitEvent: false });
            return;
        }

        // samo normalizacija tipa (npr. string -> NgbDate) bez semantičke promene
        if (current && currentRaw !== current) {
            this.baseFormGroup.get('DatumOtpremnice')?.patchValue(current, { emitEvent: false });
            this.baseFormGroup.get('DatumOtpremnice')?.updateValueAndValidity({ emitEvent: false });
        }
    }
    canDeactivate(): boolean {
        const ok = super.canDeactivate();

        if (!ok && (window as any).__YT_FW_DEBUG_UNSAVED === true) {
            this.debugUnsavedChanges(this.SavedItem, this.baseFormGroup.getRawValue());
        }

        return ok;
    }

    private normalizeToNgbDate(value: any): NgbDate | null {
        if (!value) return null;
        if (value instanceof NgbDate) return value;
        if (typeof value === 'object' && value.year != null && value.month != null && value.day != null) {
            return new NgbDate(Number(value.year), Number(value.month), Number(value.day));
        }
        const d = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(d.getTime())) return null;
        return new NgbDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
    }

    private ngbDateEquals(a: NgbDate | null, b: NgbDate | null): boolean {
        if (!a && !b) return true;
        if (!a || !b) return false;
        return a.year === b.year && a.month === b.month && a.day === b.day;
    }


    forDatumParameter(datum: NgbDate) {
        this.danParametar.Name = "day";
        this.danParametar.Value = datum.day;
        this.mesecParametar.Name = "month";
        this.mesecParametar.Value = datum.month;
        this.godinaParametar.Name = "year";
        this.godinaParametar.Value = datum.year;
        this.parameterListDatum = List([]);
        this.parameterListDatum = this.parameterListDatum.push(this.danParametar);
        this.parameterListDatum = this.parameterListDatum.push(this.mesecParametar);
        this.parameterListDatum = this.parameterListDatum.push(this.godinaParametar);
    }

    onDatumChange(value) {
        if (value != null) {
            if (this.Item.ID > 0 && this.router.url == "/eotpremnice/izeotpremnica") {
                if (this.SavedItem != null
                    && this.SavedItem["Datum"] != null
                    && this.SavedItem["Datum"]["month"] != value.month
                    && this.SavedItem["Datum"] != value && this.baseFormGroup.get("Datum").value != value
                    && !this.hasUserRights) {
                    alert("Nemate prava da promenite datum na neki koji nije u istom mesecu!");
                    setTimeout(() => {
                        this.baseFormGroup.patchValue({ Datum: this.SavedItem["Datum"] });
                        this.baseFormGroup.get('Datum').updateValueAndValidity();
                        this.changeDetectorRef.markForCheck();
                    }, 0);
                }
                //  this.onDaniChange(this.baseFormGroup.get('Dani').value);
                //  this.onDaniVazenjaChange(this.baseFormGroup.get('DaniVazenja').value);
            } else {
                let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
                this.TransferParameters = this.TransferParameters.set(0, parameterList);
                this.getBrojDokumenta();
                // this.onDaniChange(this.baseFormGroup.get('Dani').value);
                // this.onDaniVazenjaChange(this.baseFormGroup.get('DaniVazenja').value);

            }
            // this.forDatumParameter(value);         
        }
        // Čuvaj isti tip (NgbDate) i izbegni emitEvent da ne pravi sporedne efekte.
        this.baseFormGroup.get("DatumOtpremnice")?.patchValue(value, { emitEvent: false });
        this.baseFormGroup.get('DatumOtpremnice').updateValueAndValidity({ emitEvent: false });
    }

    onPodVrstaSelect(value: PodVrstaDokumentaStavkaView) {
        if (value != null) {
            this.getBrojDokumenta();
            if (!this.modelData.MainList.LoadFormControlDataOnInit)
                this.getFormControlData('eotpremnice/izeotpremnica', this.fc.PodVrstaDokumentaStavkaID.value);
            // if (this.Item.ID == -1 && value.OdgovornoLiceID != null) {
            //     this.baseFormGroup.patchValue({ OdgovornoLiceID: value.OdgovornoLiceID });
            //     this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();
            // }
            this.podvrstaDokumentaGn = value.PodvrstaDokumentaGn;

            let parameterList: List<QueryParameter> = List([new QueryParameter('Dokum', this.Item)]);
            // parameterList.clear();
            this.brojDecimala = value.BrojDecimala;
            parameterList = List([new QueryParameter('BrojDecimala', value.BrojDecimala)]);
            // this.TransferParameters = this.TransferParameters.set(5, parameterList);
            // parameterList.clear();
        }
    }

    onRestoreClick(): void {
        this.Reset(true).subscribe((result) => {
            if (result) {
                //console.log('Restore successfully executed');
            } else {
                //console.log('Restore was cancelled by the user');
            }
        });
    }
    setBrojOtpremnice(): Observable<any> {
        let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
        let broj: number = Number(this.baseFormGroup.get("Broj").value);
        let datum: NgbDate = this.baseFormGroup.get("Datum").value;

        if (podvrstaid && broj && datum) {
            return this.baseDataService.GetData(
                'Eotpremnica',
                'GetBrojDokumentaSaFormatom',
                {
                    PodVrstaDokumentaStavkaID: podvrstaid,
                    BrojDokumenta: broj,
                    Godina: datum.year
                }
            ).pipe(
                tap(data => {
                    this.baseFormGroup.get("BrojOtpremnice")?.patchValue(data);
                    this.baseFormGroup.get("BrojOtpremnice")?.updateValueAndValidity();
                })
            );
        }

        return of(null);
    }


    getBrojDokumenta() {
        let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
        let datum = this.baseFormGroup.get('Datum').value;
        let _this = this;

        if (this.Item.ID == -1 && podvrstaid && datum) {
            this.baseDataService.GetData('Eotpremnica', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
                .subscribe(data => {
                    if (_this.baseFormGroup.get('Datum').value) {
                        this.baseFormGroup.patchValue({ Broj: data });
                        this.baseFormGroup.get('Broj').updateValueAndValidity();
                        this.PopuniBrojIDatumOtpremnice();
                    }

                },
                    error => {
                        if (error instanceof HttpErrorResponse) {
                            let _message;
                            _message = this.errorService.getServerMessage(error);

                            this.translateService.get(_message)
                                .subscribe(translate => {
                                    this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translate, "warning", ConfirmationDialogButtons.Ok);
                                    this.ResetValues(true, false);
                                });
                        }
                    }
                )

            // if (this.fcd["NacinOtpremeID"].IsVisible == false) {
            //     this.baseFormGroup.patchValue({ NacinOtpremeID: 1 });
            //     this.baseFormGroup.get('NacinOtpremeID').updateValueAndValidity();
            // }
        }
    }
    onDatumOtpremniceChange(value) { }

    toggleCollapseOtpremnica(event?: MouseEvent) {
        if (this.izlazna) {
            if (event) {
                event.stopPropagation(); // spreči dupli click
            }
            this.collapsedOtpremnica = !this.collapsedOtpremnica
        }
    }
    toggleCollapseDetaljiOOtpremnici(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOOtpremnici = !this.collapsedDetaljiOOtpremnici
    }
    toggleCollapseDetaljiOPosiljaocu(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOPosiljaocu = !this.collapsedDetaljiOPosiljaocu;
    }
    toggleCollapseDetaljiOOtpremi(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOOtpremi = !this.collapsedDetaljiOOtpremi;
    }
    toggleCollapseDetaljiOPrimaocu(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiOPrimaocu = !this.collapsedDetaljiOPrimaocu
    }
    toggleCollapseDetaljiODostavi(event?: MouseEvent) {
        if (event) {
            event.stopPropagation(); // spreči dupli click
        }
        this.collapsedDetaljiODostavi = !this.collapsedDetaljiODostavi;
    }

    TipOtpremniceGetItems(items) {
        this.tipOtpremniceItems = items;
    }

    onTipOtpremniceSelect(value: TipOtpremnice) {
        this.baseFormGroup.get("TipOtpremnice")?.patchValue(value.GenericName);
        this.baseFormGroup.get('TipOtpremnice').updateValueAndValidity();
    }

    NacinOtpremeGetItems(items) {
        this.nacinOtpremeItems = items;
    }

    PrimaocGetItems(items) {
        this.primaocItems = items;
    }

    ObjekatPosiljaocaGetItems(items) {
        this.objekatPosiljaocaItems = items;
    }

    ObjekatPrimaocaGetItems(items) {
        this.objekatPrimaocaItems = items;
    }

    onNacinOtpremeSelect(value: NacinOtpreme) {

        const kurirIme = this.baseFormGroup.get("KurirIme")?.value;
        const kurirPrezime = this.baseFormGroup.get("KurirPrezime")?.value;
        const kurirLK = this.baseFormGroup.get("KurirLK")?.value;

        const imaKurirPodataka = !!kurirIme || !!kurirPrezime || !!kurirLK;

        if (this.Item.NacinOtpremeID != null) {
            if (this.baseFormGroup.get("NacinOtpremeID")?.value != this.Item.NacinOtpremeID) {
                const dialogKeys = this.getPromenaNacinaOtpremeDialogKeys(this.baseFormGroup.get("NacinOtpremeID")?.value, imaKurirPodataka);

                this.translateService.get([dialogKeys.warningKey, dialogKeys.questionKey])
                    .subscribe(translate => {
                        this.modalService.ShowConfirmationDialog(
                            translate[dialogKeys.warningKey],
                            translate[dialogKeys.questionKey],
                            'info',
                            ConfirmationDialogButtons.YesNo)
                            .result.then(
                                (result) => {
                                    if (result === false) {
                                        //ostavljamo sve kako je bilo, nema promene
                                        this.baseFormGroup.get("NacinOtpremeID")?.patchValue(this.Item.NacinOtpremeID);
                                        this.baseFormGroup.get("NacinOtpremeID").updateValueAndValidity();
                                        this.baseFormGroup.get("NacinOtpreme")?.patchValue(this.Item.NacinOtpreme);
                                        this.baseFormGroup.get("NacinOtpreme").updateValueAndValidity();
                                        return;
                                    }
                                    else {
                                        //menjamo polja u odnosu na promenu načina
                                        if (imaKurirPodataka) {
                                            if ((this.Item.NacinOtpremeID == 4 || this.Item.NacinOtpremeID == 5)
                                                && this.baseFormGroup.get("NacinOtpremeID")?.value == 1 ||
                                                this.baseFormGroup.get("NacinOtpremeID")?.value == 2 ||
                                                this.baseFormGroup.get("NacinOtpremeID")?.value == 3) {
                                                this.baseFormGroup.get("KurirIme")?.patchValue("");
                                                this.baseFormGroup.get('KurirIme').updateValueAndValidity();
                                                this.baseFormGroup.get("KurirPrezime")?.patchValue("");
                                                this.baseFormGroup.get('KurirPrezime').updateValueAndValidity();
                                                this.baseFormGroup.get("KurirLK")?.patchValue("");
                                                this.baseFormGroup.get('KurirLK').updateValueAndValidity();
                                            }
                                        }
                                        else {
                                            if ((this.baseFormGroup.get("NacinOtpremeID")?.value == 4 || this.baseFormGroup.get("NacinOtpremeID")?.value == 5)
                                                && (this.Item.NacinOtpremeID == 1 || this.Item.NacinOtpremeID == 2 || this.Item.NacinOtpremeID == 3)) {
                                                let idParametar = new QueryParameter("eOtpremnicaID", this.Item.ID);

                                                this.baseDataService
                                                    .Get("EOtpremnicaPrevoz", "DeleteByEOtprDokumentID", [idParametar], null)
                                                    .subscribe(
                                                        (poruka: any) => {
                                                            this.translateService
                                                                .get(['EOTPREMNICAPREVOZ.DELETE.SUCCESS'])
                                                                .subscribe(translate => {
                                                                    setTimeout(() => {
                                                                        this.toastrService.success(
                                                                            translate['EOTPREMNICAPREVOZ.DELETE.SUCCESS'],
                                                                            poruka
                                                                        );
                                                                    }, 0)
                                                                    //osveži listu
                                                                    this.baseInlineContainer1.baseDetailList.RefreshData();
                                                                    this.baseInlineContainer1.baseInlineUpdateComponent.AddItem();
                                                                });
                                                        }
                                                        , error => {
                                                            let _message;
                                                            let translatedMessage: string = "";
                                                            if (error instanceof HttpErrorResponse) {
                                                                _message = this.errorService.getServerMessage(error);
                                                                if (_message instanceof ArrayBuffer) {
                                                                    // _message = String.fromCharCode.apply(null, new Uint8Array(_message));
                                                                    _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
                                                                    let message: string = _message;
                                                                    if (message.includes("EDOKUMENT")) {
                                                                        let messageArray: string[] = message.split(';');
                                                                        messageArray.forEach((element, index) => {
                                                                            messageArray[index] = "FW.ERRORS." + element;
                                                                        });
                                                                        this.translateService.get(messageArray)
                                                                            .subscribe(translate => {
                                                                                translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                                                                            });
                                                                    }
                                                                    else
                                                                        translatedMessage = message;
                                                                }
                                                                else {
                                                                    translatedMessage = this.errorService.getClientMessage(error.error);
                                                                }
                                                            }
                                                            this.modalService.ShowConfirmationDialog("Problemi kod brisanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

                                                        }
                                                    );
                                            }
                                        }
                                    }
                                }
                            )
                    });
            }
        }

        if (value.Naziv === this.SOPSTVENI_PREVOZ) {
            this.angazovanPrevoznik = false;
            this.sopstveniPrevoz = true;
        } else {
            this.angazovanPrevoznik = value.Prevoznik;
            this.sopstveniPrevoz = false;
        }
        // this.baseFormGroup.get("NacinOtpreme")?.patchValue(value.Naziv);
        //this.baseFormGroup.get('NacinOtpreme').updateValueAndValidity();

        // this.baseFormGroup.get("KurirIme")?.patchValue("");
        // this.baseFormGroup.get('KurirIme').updateValueAndValidity();
        // this.baseFormGroup.get("KurirPrezime")?.patchValue("");
        // this.baseFormGroup.get('KurirPrezime').updateValueAndValidity();
        // this.baseFormGroup.get("KurirLK")?.patchValue("");
        // this.baseFormGroup.get('KurirLK').updateValueAndValidity();

        let paramList = List<QueryParameter>();

        // if (this.sopstveniPrevoz) {

        //     paramList = paramList.push(
        //         new QueryParameter('sopstveniPrevoz', true)
        //     );

        //     paramList = paramList.push(
        //         new QueryParameter('firmaData', this.getFirmaPrevozData())
        //     );

        //     this.TransferParameters = this.TransferParameters.set(2, paramList);
        // }
        // else {
        //     // očisti slot 2 ako nije sopstveni
        //     this.TransferParameters = this.TransferParameters.set(2, List<QueryParameter>());
        // }
        if (this.sopstveniPrevoz) {
            this.trySetPrevozParameters();
        } else {
            //  const paramList = List([
            //     new QueryParameter('sopstveniPrevoz', false),
            //     new QueryParameter('firmaData', null)
            // ]);
            this.TransferParameters = this.TransferParameters.set(2, List<QueryParameter>());
            // this.TransferParameters = this.TransferParameters.set(2, paramList);
        }
    }

    private getPromenaNacinaOtpremeDialogKeys(noviNacinOtpremeID: number, imaKurirPodataka: boolean): { warningKey: string, questionKey: string } {
        if (((noviNacinOtpremeID === 4 || noviNacinOtpremeID === 5) && !imaKurirPodataka)
            || (noviNacinOtpremeID === 1 || noviNacinOtpremeID === 2 || noviNacinOtpremeID === 3) && imaKurirPodataka) {
            return {
                warningKey: 'EOTPREMNICA.PROMENANACINAOTPREME.WARNING',
                questionKey: 'EOTPREMNICA.PROMENANACINAOTPREME.QUESTION'
            };
        }
        else {
            return {
                warningKey: 'EOTPREMNICA.PROMENANACINAOTPREME.WARNING2',
                questionKey: 'EOTPREMNICA.PROMENANACINAOTPREME.QUESTION'
            };
        }
    }

    // private waitForLayoutStabilize(callback: () => void, maxChecks = 20) {
    //     let lastHeight = document.body.scrollHeight;
    //     let checks = 0;

    //     const check = () => {
    //         const newHeight = document.body.scrollHeight;

    //         if (newHeight === lastHeight || checks >= maxChecks) {
    //             callback();
    //         } else {
    //             lastHeight = newHeight;
    //             checks++;
    //             requestAnimationFrame(check);
    //         }
    //     };

    //     requestAnimationFrame(check);
    // }

    PopuniBrojIDatumOtpremnice() {
        this.setBrojOtpremnice().subscribe(() => {
            this.baseFormGroup.get("DatumOtpremnice")?.patchValue(this.baseFormGroup.get("Datum")?.value);
            this.baseFormGroup.get('DatumOtpremnice').updateValueAndValidity();
        });
    }

    // getFirmaPrevozData() {
    //     if (this.selektovaniPosiljaoc && this.selektovaniPosiljaoc.ID) {
    //         return {
    //             //PrevoznikID: this.baseFormGroup.get('NazivPosiljaoca')?.value,
    //             PrevoznikID: this.selektovaniPosiljaoc.ID,
    //             NazivPrevoznika: this.baseFormGroup.get('NazivPosiljaoca')?.value,
    //             PibPrevoznika: this.baseFormGroup.get('PibPosiljaoca')?.value,
    //             MaticniBrojPrevoznika: this.baseFormGroup.get('MaticniBrojPosiljaoca')?.value,
    //             UlicaPrevoznika: this.baseFormGroup.get('UlicaPosiljaoca')?.value,
    //             GradPrevoznika: this.baseFormGroup.get('GradPosiljaoca')?.value,
    //             PostanskiBrojPrevoznika: this.baseFormGroup.get('PostanskiBrojPosiljaoca')?.value
    //         };
    //     }
    //     else {
    //         return null;
    //     }
    // }

    private trySetPrevozParameters() {

        // if (!this.sopstveniPrevoz || !this.selektovaniPosiljaoc) {
        //     return;
        // }
        if (!this.sopstveniPrevoz || !this.selektovaniPosiljaoc?.ID) {
            return;
        }

        const firmaData = {
            PrevoznikID: this.selektovaniPosiljaoc.ID,
            NazivPrevoznika: this.baseFormGroup.get('NazivPosiljaoca')?.value,
            PibPrevoznika: this.baseFormGroup.get('PibPosiljaoca')?.value,
            MaticniBrojPrevoznika: this.baseFormGroup.get('MaticniBrojPosiljaoca')?.value,
            UlicaPrevoznika: this.baseFormGroup.get('UlicaPosiljaoca')?.value,
            GradPrevoznika: this.baseFormGroup.get('GradPosiljaoca')?.value,
            PostanskiBrojPrevoznika: this.baseFormGroup.get('PostanskiBrojPosiljaoca')?.value
        };

        const paramList = List([
            new QueryParameter('sopstveniPrevoz', true),
            new QueryParameter('firmaData', firmaData)
        ]);

        this.TransferParameters = this.TransferParameters.set(2, paramList);
    }

    private loadCompanyData() {
        if (this.selektovaniPosiljaoc) {
            return; // već učitano
        }

        // this.baseDataService
        //     .Get('firma', 'GetCompanyIdView', null, CompanyView)
        //     .subscribe((data: any) => {
        //         if (data) {
        //             this.selektovaniPosiljaoc = data as CompanyView;;
        //         }
        //     });

        this.baseDataService
            .Get('firma', 'GetCompanyIdView', null, CompanyView)
            .subscribe((data: any) => {

                if (data) {
                    this.selektovaniPosiljaoc = data as CompanyView;

                    // ako je user već kliknuo sopstveni prevoz
                    if (this.sopstveniPrevoz) {
                        this.trySetPrevozParameters();
                    }
                }
            });

    }

    private scrollToFormTopDeferred(): void {
        this.changeDetectorRef.detectChanges();

        this.ngZone.runOutsideAngular(() => {
            requestAnimationFrame(() => {
                this.scrollToTopNow();

                setTimeout(() => this.scrollToTopNow(), 50);
                setTimeout(() => this.scrollToTopNow(), 150);
                setTimeout(() => this.scrollToTopNow(), 300);
            });
        });
    }

    private scrollToTopNow(): void {
        const topEl = this.formTop?.nativeElement as HTMLElement | null;

        if (topEl) {
            topEl.scrollIntoView({
                behavior: 'auto',
                block: 'start',
                inline: 'nearest'
            });
        }

        window.scrollTo(0, 0);

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        const scrollableParent = this.findScrollableParent(topEl);
        if (scrollableParent) {
            scrollableParent.scrollTop = 0;
        }
    }

    private findScrollableParent(el: HTMLElement | null): HTMLElement | null {
        let parent = el?.parentElement;

        while (parent) {
            const style = window.getComputedStyle(parent);
            const overflowY = style.overflowY;

            if ((overflowY === 'auto' || overflowY === 'scroll') &&
                parent.scrollHeight > parent.clientHeight) {
                return parent;
            }

            parent = parent.parentElement;
        }

        return null;
    }



    KreirajIzlaznuOtpremnicu() {
        this.dozvoliSnimanje = true;
        //** Detalji o otpremnici */
        this.setBrojOtpremnice().subscribe(() => {
            this.baseFormGroup.get("DatumOtpremnice")?.patchValue(this.baseFormGroup.get("Datum")?.value);
            this.baseFormGroup.get('DatumOtpremnice').updateValueAndValidity();
            const selektovaniTipOtpremnice = this.tipOtpremniceItems.find(x => x.ID === this.baseFormGroup.get("TipOtpremniceID")?.value);
            if (selektovaniTipOtpremnice) {
                this.baseFormGroup.get("TipOtpremnice")?.patchValue(selektovaniTipOtpremnice.GenericName);
                this.baseFormGroup.get('TipOtpremnice').updateValueAndValidity();
            }
            const selektovaniNacinOtpreme = this.nacinOtpremeItems.find(x => x.ID === this.baseFormGroup.get("NacinOtpremeID")?.value);
            if (selektovaniNacinOtpreme) {
                this.baseFormGroup.get("NacinOtpreme")?.patchValue(selektovaniNacinOtpreme.Naziv);
                this.baseFormGroup.get('NacinOtpreme').updateValueAndValidity();
            }
            //** Detalji o pošiljocu */
            if (this.selektovaniPosiljaoc) {
                this.baseFormGroup.get("PosiljaocID")?.patchValue(this.selektovaniPosiljaoc.ID);
                this.baseFormGroup.get('PosiljaocID').updateValueAndValidity();
                this.baseFormGroup.get("NazivPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.SNaziv);
                this.baseFormGroup.get('NazivPosiljaoca').updateValueAndValidity();
                this.baseFormGroup.get("PibPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.Pib);
                this.baseFormGroup.get('PibPosiljaoca').updateValueAndValidity();
                this.baseFormGroup.get("UlicaPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.Adresa);
                this.baseFormGroup.get('UlicaPosiljaoca').updateValueAndValidity();
                this.baseFormGroup.get("GradPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.Mesto);
                this.baseFormGroup.get('GradPosiljaoca').updateValueAndValidity();
                this.baseFormGroup.get("PostanskiBrojPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.PostBroj);
                this.baseFormGroup.get('PostanskiBrojPosiljaoca').updateValueAndValidity();
                this.baseFormGroup.get("MaticniBrojPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.MaticniBroj);
                this.baseFormGroup.get('MaticniBrojPosiljaoca').updateValueAndValidity();
                this.baseFormGroup.get("GlnPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.Gln);
                this.baseFormGroup.get('GlnPosiljaoca').updateValueAndValidity();
                // this.baseFormGroup.get("EmailPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.);
                // this.baseFormGroup.get('EmailPosiljaoca').updateValueAndValidity();
                // this.baseFormGroup.get("TelefonPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.);
                // this.baseFormGroup.get('TelefonPosiljaoca').updateValueAndValidity();
                // this.baseFormGroup.get("JBKJSPosiljaoca")?.patchValue(this.selektovaniPosiljaoc.Jbkjs);
                // this.baseFormGroup.get('JBKJSPosiljaoca').updateValueAndValidity();


            }
            //** Detalji o otpremi */
            const selektovaniObjekatPosiljaoca = this.objekatPosiljaocaItems
                .find(x => x.ID === this.baseFormGroup.get("ObjekatPosiljaocaID")?.value);
            if (selektovaniObjekatPosiljaoca) {
                this.baseFormGroup.get("UlicaOtpreme")?.patchValue(selektovaniObjekatPosiljaoca.Adresa);
                this.baseFormGroup.get('UlicaOtpreme').updateValueAndValidity();
                // this.baseFormGroup.get("DodatnaUlicaOtpreme")?.patchValue(selektovaniObjekatPosiljaoca.);
                // this.baseFormGroup.get('DodatnaUlicaOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("GradOtpreme")?.patchValue(selektovaniObjekatPosiljaoca.MestoNaziv);
                this.baseFormGroup.get('GradOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("PostanskiBrojOtpreme")?.patchValue(selektovaniObjekatPosiljaoca.PostBroj);
                this.baseFormGroup.get('PostanskiBrojOtpreme').updateValueAndValidity();
                // this.baseFormGroup.get("PodentitetOtpreme")?.patchValue(selektovaniObjekatPosiljaoca.);
                // this.baseFormGroup.get('PodentitetOtpreme').updateValueAndValidity();
                // this.baseFormGroup.get("BrojUUliciOtpreme")?.patchValue(selektovaniObjekatPosiljaoca.);
                // this.baseFormGroup.get('BrojUUliciOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("GlnPosiljaoca")?.patchValue(selektovaniObjekatPosiljaoca.Gln);
                this.baseFormGroup.get('GlnPosiljaoca').updateValueAndValidity();
            } else {
                this.baseFormGroup.get("UlicaOtpreme")?.patchValue(this.baseFormGroup.get("UlicaPosiljaoca").value);
                this.baseFormGroup.get('UlicaOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("DodatnaUlicaOtpreme")?.patchValue(this.baseFormGroup.get("DodatnoUlicaPosiljaoca").value);
                this.baseFormGroup.get('DodatnaUlicaOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("GradOtpreme")?.patchValue(this.baseFormGroup.get("GradPosiljaoca").value);
                this.baseFormGroup.get('GradOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("PostanskiBrojOtpreme")?.patchValue(this.baseFormGroup.get("PostanskiBrojPosiljaoca").value);
                this.baseFormGroup.get('PostanskiBrojOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("PodentitetOtpreme")?.patchValue(this.baseFormGroup.get("PodentitetPosiljaoca").value);
                this.baseFormGroup.get('PodentitetOtpreme').updateValueAndValidity();
                this.baseFormGroup.get("BrojUUliciOtpreme")?.patchValue(this.baseFormGroup.get("BrojUUliciPosiljaoca").value);
                this.baseFormGroup.get('BrojUUliciOtpreme').updateValueAndValidity();
            }

            //** Detalji o primaocu */
            let selektovanJeObjekatPrimaoca: boolean = this.baseFormGroup.get("ObjekatPrimaocaID")
                && this.baseFormGroup.get("ObjekatPrimaocaID").value;
            let selektovaniObjekatPrimaoca;
            if (selektovanJeObjekatPrimaoca) {
                selektovaniObjekatPrimaoca = this.objekatPrimaocaItems
                    .find(x => x.ID === this.baseFormGroup.get("ObjekatPrimaocaID")?.value);
                selektovanJeObjekatPrimaoca = selektovanJeObjekatPrimaoca && selektovaniObjekatPrimaoca != null;
            }

            const selektovaniPrimaoc = this.primaocItems.find(x => x.ID === this.baseFormGroup.get("PrimaocID")?.value);
            if (selektovaniPrimaoc) {
                this.baseFormGroup.get("NazivPrimaoca")?.patchValue(selektovaniPrimaoc.SNaziv);
                this.baseFormGroup.get('NazivPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("PibPrimaoca")?.patchValue(selektovaniPrimaoc.Pib);
                this.baseFormGroup.get('PibPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("UlicaPrimaoca")?.patchValue(selektovaniPrimaoc.Adresa);
                this.baseFormGroup.get('UlicaPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("PostanskiBrojPrimaoca")?.patchValue(selektovaniPrimaoc.PostBroj);
                this.baseFormGroup.get('PostanskiBrojPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("GradPrimaoca")?.patchValue(selektovaniPrimaoc.Mesto);
                this.baseFormGroup.get('GradPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("MaticniBrojPrimaoca")?.patchValue(selektovaniPrimaoc.MaticniBroj);
                this.baseFormGroup.get('MaticniBrojPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("GlnPrimaoca")?.patchValue(selektovaniPrimaoc.Gln);
                this.baseFormGroup.get('GlnPrimaoca').updateValueAndValidity();
                this.baseFormGroup.get("JBKJSPrimaoca")?.patchValue(selektovaniPrimaoc.Jbkjs);
                this.baseFormGroup.get('JBKJSPrimaoca').updateValueAndValidity();
            }
            //** Detalji o primaocu */
            if (selektovanJeObjekatPrimaoca) {
                this.baseFormGroup.get("UlicaDostave")?.patchValue(selektovaniObjekatPrimaoca.ObjekatAdresa);
                this.baseFormGroup.get('UlicaDostave').updateValueAndValidity();
                // this.baseFormGroup.get("DodatnaUlicaDostave")?.patchValue(selektovaniObjekatPrimaoca.);
                // this.baseFormGroup.get('DodatnaUlicaDostave').updateValueAndValidity();
                this.baseFormGroup.get("GradDostave")?.patchValue(selektovaniObjekatPrimaoca.MestoNaziv);
                this.baseFormGroup.get('GradDostave').updateValueAndValidity();
                this.baseFormGroup.get("PostanskiBrojDostave")?.patchValue(selektovaniObjekatPrimaoca.ObjekatPostBroj);
                this.baseFormGroup.get('PostanskiBrojDostave').updateValueAndValidity();
                // this.baseFormGroup.get("PodentitetDostave")?.patchValue(selektovaniObjekatPrimaoca.);
                // this.baseFormGroup.get('PodentitetDostave').updateValueAndValidity();
                // this.baseFormGroup.get("BrojUUliciDostave")?.patchValue(selektovaniObjekatPrimaoca.);
                // this.baseFormGroup.get('BrojUUliciDostave').updateValueAndValidity();
                this.baseFormGroup.get("GlnPrimaoca")?.patchValue(selektovaniObjekatPrimaoca.Gln);
                this.baseFormGroup.get('GlnPrimaoca').updateValueAndValidity();
            } else {
                // Ako nije odabran objekat kupca prepisujemo podatke kupca(primaoca)
                this.baseFormGroup.get("UlicaDostave")?.patchValue(this.baseFormGroup.get("UlicaPrimaoca").value);
                this.baseFormGroup.get('UlicaDostave').updateValueAndValidity();
                this.baseFormGroup.get("DodatnaUlicaDostave")?.patchValue(this.baseFormGroup.get("DodatnoUlicaPrimaoca").value);
                this.baseFormGroup.get('DodatnaUlicaDostave').updateValueAndValidity();
                this.baseFormGroup.get("GradDostave")?.patchValue(this.baseFormGroup.get("GradPrimaoca").value);
                this.baseFormGroup.get('GradDostave').updateValueAndValidity();
                this.baseFormGroup.get("PostanskiBrojDostave")?.patchValue(this.baseFormGroup.get("PostanskiBrojPrimaoca").value);
                this.baseFormGroup.get('PostanskiBrojDostave').updateValueAndValidity();
                this.baseFormGroup.get("PodentitetDostave")?.patchValue(this.baseFormGroup.get("PodentitetPrimaoca").value);
                this.baseFormGroup.get('PodentitetDostave').updateValueAndValidity();
                this.baseFormGroup.get("BrojUUliciDostave")?.patchValue(this.baseFormGroup.get("BrojUUliciPrimaoca").value);
                this.baseFormGroup.get('BrojUUliciDostave').updateValueAndValidity();
            }

            // Otvaramo kolepse i probamo da snimimo
            this.collapsedDetaljiOOtpremnici = false;
            this.collapsedDetaljiOPosiljaocu = false;
            this.collapsedDetaljiOOtpremi = false;
            this.collapsedDetaljiOPrimaocu = false;
            this.collapsedDetaljiODostavi = false;

            this.baseFormGroup.updateValueAndValidity({ emitEvent: false });
            this.SaveItem()
            //     this.SaveItem().then((data: any) => {
            //     this.baseFormGroup.updateValueAndValidity({ emitEvent: false });
            //     this.SavedItem = this.baseFormGroup.getRawValue();
            //     this.baseFormGroup.markAsPristine();
            //     this.baseFormGroup.markAsUntouched();
            // });

        });
    }
}

function checkDatumeSaDatumomDokumenta(datumIDKey: string, mainThis: any) {
    return (group: FormGroup): { [key: string]: any } => {

        let genericName: string = null;

        if (mainThis.podvrstaDokumentaGn)
            genericName = mainThis.podvrstaDokumentaGn;

        if (genericName == "eotp_izlaz") {
            return null;
        }

        return null;
    }
}

function checkByNacinOtpremeLicno(nacinOtpremeIDKey: string, imeKuriraKey: string, prezimeKuriraKey: string, licnaKartaKuriraKey: string) {
    return (group: FormGroup): { [key: string]: any } => {
        let nacinOtpremeID = group.controls[nacinOtpremeIDKey].value;
        let imeKurira = group.controls[imeKuriraKey].value;
        let prezimeKurira = group.controls[prezimeKuriraKey].value;
        let licnaKartaKurira = group.controls[licnaKartaKuriraKey].value;

        if (nacinOtpremeID == null && imeKurira == null && prezimeKurira == null && licnaKartaKurira == null)
            return null;
        else {
            if ((nacinOtpremeID == 4 || nacinOtpremeID == 5) && (imeKurira == "" || prezimeKurira == "" || imeKurira == null || prezimeKurira == null || licnaKartaKurira == "" || licnaKartaKurira == null))
                return { checkControlsNacinOtpreme: { valid: false, message: 'EOTPREMNICA.NACINOTPREME.LICNO.VALIDATION' } };
            else
                return null;
        }



    }


}
